/**
 * @file HowToUse.tsx
 */
import { DownloadInstructions } from "../components/DownloadInstructions";
import { Step } from "../components/Step";
import SwOn from "./img/SwOn.png"
import SwZero from "./img/SwZero.png"
import PrepareStep1 from "./img/PrepareStep1.png"
import PrepareStep2 from "./img/PrepareStep2.png"
import PrepareStep3 from "./img/PrepareStep3.png"
import UseStep1 from "./img/UseStep1.png"
import UseStep2 from "./img/UseStep2.png"
import UseStep3 from "./img/UseStep3.png"
import UseStep4 from "./img/UseStep4.png"
import UseStep5 from "./img/UseStep5.png"
import UseStep6 from "./img/UseStep6.png"
import UseStep7 from "./img/UseStep7.png"
import UseStep8 from "./img/UseStep8.png"
import UseStep9 from "./img/UseStep9.png"

const steps_prepare = [
  { step: "1.", text: "GOC200-70をUSBケーブルを使用してPCに接続してください。" ,
    image: PrepareStep1, alt: "GOC200-70をPCに接続" },

  { step: "2.", text: <>GOC-200の電源が切れた状態から，
      <img src={SwOn} alt="[電源]" className="switch-image" />を押しながら<img src={SwZero} alt="[AIRゼロ]" className="switch-image" />を押し，<img src={SwOn} alt="[電源]" className="switch-image" />を離してください。<br />
      ロギングデータ読み出しモードが起動し，「Stb(スタンバイ)」と表示されます。</> ,
    image: PrepareStep2, alt: "GOC-200の電源を入れる" },

  { step: "3.", text: "GOC-200をGOC200-70の上に置いてください。" ,
    image: PrepareStep3, alt: "GOC-200をGOC200-70の上に置く",
    point_text: "GOC200-70の裏と表のどちらにGOC-200を置いても問題なくロギングデータ読み取り可能です。" },
];

const steps_use = [
  { step: "1.", text: "GasLogReader.exeを起動してください。", 
    image: UseStep1, alt: "GasLogReader起動時画面",
    point_text: "初回起動時には，利用規約・プライバシーポリシーの確認画面が表示されます。ご同意いただける場合は同意するにチェックをして[次へ]を押してください。" },
  
  { step: "2.", text: "ドロップダウンリストから読み取り機のポートを選択してください。" ,
    image: UseStep2, alt: "ポート選択" },

  { step: "3.", text: "[スキャン開始]を押してください。周囲にあるロギングデータ読み出しモードのGOC-200が表示されます。" ,
    image: UseStep3, alt: "スキャン開始" },

  { step: "4.", text: "ロギングデータの読み取りをしたい機器を選択してください。" ,
    image: UseStep4, alt: "機器選択" },

  { step: "5.", text: "読み取りモードを選択してください。",
    image: UseStep5, alt: "読み取りモード選択",
    point_text: <>「高速モード」：ログ抽出期間のみのデータを取り出し<br />
    「全データモード」：すべての期間のデータを取り出し<br />
    読み取りモードの詳細は取扱説明書の「2.3.2 読み取りモード」をご覧ください。</> },

  { step: "6.", text: "[スタート]を押してください。ロギングデータの読み取りが完了すると，データが表示されます。",
    image: UseStep6, alt: "読み取り開始" ,
    point_text: "表示されたデータの説明は取扱説明書の「4.2.1 ロギングデータを読み取る」手順6のポイントをご覧ください。"},

  { step: "7.", text: "ロギングデータを保存する場合は[csvファイル出力]を押して，任意の場所に保存してください" ,
    image: UseStep7, alt: "csvファイル出力" },

  { step: "8.", text: "終了する場合は，GasLogReaderのウインドウ右上の「×」をクリックしてください。",
    image: UseStep8, alt: "GasLogReader終了" },

  { step: "9.", text: <>GOC-200の<img src={SwOn} alt="[電源]" className="switch-image" />を押して，電源を切ってください。</>,
    image: UseStep9, alt: "GOC-200の電源を切る",
    point_text: <>GOC-200はロギングデータ読み出しモードでは、ガス濃度の監視はできません。<br />
    ロギングデータ読み取り終了後，GOC-200の電源を必ず切ってください。次に電源を入れると通常モードで動作します。</>},
];

/**
 * How to use
 * @returns {JSX.Element} GasLogReaderの使い方のJSX要素
 */
export function HowToUse(): JSX.Element {
  return (
    <div>
      <section className="c-section">
        <h2 className="p-heading-2">GasLogReaderの使い方</h2>        
        <p className="c-text">
          GasLogReaderは，GOC200-70を用いてGOC-200のロギングデータを読み取るためのソフトウェアです。
          以下の手順に従って，GasLogReaderを使用してください。
        </p>
        <DownloadInstructions
          downloadLink="/gas-log-reader/HowToDownload"
          driverLink="/gas-log-reader/HowToInstallDeviceDriver"
        />

        <h3 className="p-heading-3">GOC200-70とGOC-200の準備</h3>
        {steps_prepare.map((step, index) => (
          <Step key={index} step={step.step} text={step.text} image={step.image} point_text={step.point_text} />
        ))}
        <h3 className="p-heading-3">GasLogReaderの操作</h3>
        {steps_use.map((step, index) => (
          <Step key={index + steps_prepare.length} step={step.step} text={step.text} image={step.image} point_text={step.point_text} />
        ))}
      </section>
    </div>
  );
}
